module.exports = __webpack_public_path__ + "static/media/athletics-icon.c887e20a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/athletics-icon.svg
// module id = 41
// module chunks = 0